import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconComponent } from 'angular-svg-icon';
import { AssignmentService } from '../../../_services/assignment.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { StartupProfileService } from '../../../../panel/_services/startup-profile.service';
import { SkeletonModule } from 'primeng/skeleton';
import { AuthService } from '../../../../auth/_services/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-assignments',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NgbAccordionModule,
    SkeletonModule,
    SvgIconComponent,
  ],
  templateUrl: './assignments.component.html',
  styleUrl: './assignments.component.scss'
})
export class AssignmentsComponent implements OnChanges {
  @Input() courseId!: number;
  @Input() loading: boolean = true;

  upcomingAssignment: any = [];
  pastAssignment: any = [];

  constructor(
    private route: ActivatedRoute,
    private assignmentService: AssignmentService,
    private startupService: StartupProfileService,
    private authService: AuthService
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.courseId) {
      if (this.authService.isInRole('Founder')) {
        // Founder logic - get startup members and their assignments
        this.startupService.getForedit(this.route.snapshot.queryParamMap.get('startupid')).subscribe(res => {
          this.assignmentService.getStudentAssignments(this.courseId, res?.members?.map((x: any) => x.id), this.route.snapshot.queryParamMap.get('startupid')).subscribe((res: any) => {
            this.processAssignments(res);
          })
        })
      } else if ((this.authService.isAdmin || this.authService.isTenantAdminOrOperator) && this.route.snapshot.queryParamMap.get('startupid')) {
        // Admin logic - get assignments for the startup scope (will include admin-submitted homework)
        this.assignmentService.getStudentAssignments(this.courseId, null, this.route.snapshot.queryParamMap.get('startupid')).subscribe((res: any) => {
          this.processAssignments(res);
        })
      }
    }
  }

  private processAssignments(res: any) {
    res.forEach((x: any) => {
      if (x.isSubmitted) {
        x.onTime = new Date(x.submitDate) < new Date(x.dueDate);
      }
    })
    this.upcomingAssignment = res.filter((x: any) => new Date(x.dueDate) > new Date());
    this.pastAssignment = res.filter((x: any) => new Date(x.dueDate) < new Date());
    this.loading = false;
  }
}
